<template>
    <div id="schoolEdit">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <div class="title">基础信息</div>

                    <el-form-item label="学校名称" prop="name">
                        <el-input v-model="formData.name" :maxlength="45" placeholder="请输入学校名称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="学校全称" prop="fullName">
                        <el-input v-model="formData.fullName" :maxlength="45" placeholder="请输入学校全称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="学校简称" prop="simpleName">
                        <el-input v-model="formData.simpleName" :maxlength="45" placeholder="请输入学校简称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="managerName">
                        <el-input v-model="formData.managerName" :maxlength="20" placeholder="请输入联系人"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="联系号码" prop="managerMobile">
                        <el-input v-model="formData.managerMobile" :maxlength="11" placeholder="请输入手机号码"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="managerEmail">
                        <el-input v-model="formData.managerEmail" :maxlength="30" placeholder="请输入邮箱"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="所属区域" prop="managerEmail">
                        <location-selector v-model="locationArray" :hasDistAll="false"
                                           ref="locationSelector"></location-selector>
                    </el-form-item>

                    <el-form-item label="详细地址">
                        <el-input v-model="formData.address" :maxlength="50" placeholder="请输入详细地址"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="组织机构代码">
                        <el-input v-model="formData.orgCode" placeholder="请输入组织机构代码"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="创办类型">
                        <el-radio-group v-model="formData.isPublic">
                            <el-radio :label="1">教办</el-radio>
                            <el-radio :label="2">民办</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="域名">
                        <el-input v-model="formData.domainName" placeholder="请输入域名"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <div class="title">设置信息</div>
                    <el-form-item label="经销商">
                        <el-select size="medium" v-model="formData.bussinessNumber" placeholder="请选择">
                            <el-option v-for="dealerItem in dealerList" :key="dealerItem.bussinessNumber"
                                       :label="dealerItem.bussinessName"
                                       :value="dealerItem.bussinessNumber"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="客户端类型" prop="clientType">
                        <el-radio-group v-model="formData.clientType">
                            <el-radio label="1">企业微信</el-radio>
                            <el-radio label="2">农行</el-radio>
                            <el-radio label="12">企业微信及农行</el-radio>
                            <el-radio label="3">建行生活</el-radio>
                            <el-radio label="4">建行App</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="套件类型" v-if="formData.clientType == 1 || formData.clientType == 12 || formData.clientType == 4">
                        <el-radio-group v-model="formData.suiteType">
                            <el-radio :label="1">微校+老套件</el-radio>
                            <el-radio :label="2">微校+新套件</el-radio>
                            <el-radio :label="3">成长乐园</el-radio>
                            <el-radio :label="4">成长乐园新</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div v-show="formData.clientType == 1 || formData.clientType == 12 || formData.clientType == 4">
                        <el-form-item label="框架类型">
                            <el-radio-group v-model="formData.useNew">
                                <el-radio :label="1">微校+</el-radio>
                                <el-radio :label="4">成长乐园</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否用新手机端页面">
                            <el-radio-group v-model="formData.isNewMobile">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否与企业微信同步">
                            <el-radio-group v-model="formData.syncForWx">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                         <el-form-item label="是否开启通讯录同步" v-if="formData.syncForWx == 1">
                            <el-radio-group v-model="formData.syncForWxAddress">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                         <el-form-item label="是否开启家校通讯录同步" v-if="formData.syncForWx == 1">
                            <el-radio-group v-model="formData.syncForWxAddressSchool">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="是否新家校">
                            <el-radio-group v-model="formData.isExternalContact">
                                <el-radio :label="2">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div v-show="formData.clientType == 2 || formData.clientType == 3 || formData.clientType == 12 || formData.clientType == 4">
                        <el-form-item label="获客来源" prop="guestSourceCode">
                            <el-select size="medium" v-model="formData.guestSourceCode" placeholder="请选择">
                                <el-option v-for="item in guestSourceList" :key="item.code" :label="item.value"
                                           :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属支行" prop="subBranchCode">
                            <el-select size="medium" v-model="formData.subBranchCode" placeholder="请选择">
                                <el-option v-for="item in branchList" :key="item.code" :label="item.value"
                                           :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="接入日期" prop="joinDate">
                            <el-date-picker
                                v-model="formData.joinDate"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </div>

                    <el-form-item label="学校类型">
                        <el-radio-group v-model="formData.schoolType">
                            <el-radio :label="1">独立院校/园所</el-radio>
                            <el-radio :label="2">集团校/园所</el-radio>
                            <el-radio :label="3">分校/分园</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="集团名称" v-if="formData.schoolType == 2" prop="group">
                        <el-input v-model="formData.groupName" placeholder="请输入集团名称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item v-if="formData.schoolType == 3" label="所属总校/总园" prop="group">
                        <el-select size="medium" v-model="formData.groupSchoolId" placeholder="请选择">
                            <el-option v-for="groupItem in groupList" :key="groupItem.id" :label="groupItem.name"
                                       :value="groupItem.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="订餐范围">
                        <location-selector hasProvinceNone v-model="orderRangeArray"
                                           ref="locationSelectorOrderRange"></location-selector>
                    </el-form-item>
                    <div class="title">开发信息</div>
                    <el-form-item v-if="isNewWx == 1 && formData.clientType == 1" label="企业corpid明文"
                                  prop="originalCorpId">
                        <el-input v-model.trim="formData.originalCorpId" :maxlength="60" placeholder="请输入企业corpid明文"
                                 ></el-input>
                    </el-form-item>
                    <el-form-item label="数据从中台下发">
                        <el-radio-group v-model="formData.platformSync">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="开启通讯录编辑权限" v-if="formData.clientType == 1 || formData.clientType == 12 || formData.clientType == 4">
                        <el-radio-group v-model="formData.addressBookPerm">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="家校通讯录秘钥" v-show="formData.isExternalContact == 2" v-if="formData.clientType == 1 || formData.clientType == 12 || formData.clientType == 4">
                        <el-input v-model="formData.newSchoolSecret" placeholder="请输入通讯录秘钥"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="数据下发">
                        <el-radio-group v-model="formData.isPushdata">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="第三方学校id" prop="thirdSchoolId">
                        <el-input v-model="formData.thirdSchoolId" placeholder="请输入第三方学校id" :maxlength="45"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="单点登录域名">
                        <el-input v-model="formData.ssoDomainName" placeholder="请输入单点登录域名" :maxlength="45"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="对接腾讯智慧校园" v-if="formData.clientType == 1 || formData.clientType == 12 || formData.clientType == 4">
                        <el-radio-group v-model="formData.tencentSchoolVersion">
                            <el-radio :label="0">不设置</el-radio>
                            <el-radio :label="1">1.0</el-radio>
                            <el-radio :label="2">2.0</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="title">图标及二维码</div>
                    <el-form-item label="" style="width: 1100px;margin-left: -140px;" prop="logo">
                        <div class="logo-list">
                            <div class="logo-item logo-item--square">
                                <div>
                                    <uploader openDelete ref="coverUploader" pathPrefix="moduleApp"
                                              :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" :showModeCover="false"
                                              showResult="image" showMode="image" v-model="roundLogoUrl"
                                              :multiple="false"></uploader>
                                </div>
                                <div class="logo-item__text">圆Logo（不带名称）</div>
                            </div>
                            <div class="logo-item logo-item--round">
                                <div>
                                    <uploader openDelete ref="coverUploader" pathPrefix="moduleApp"
                                              :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" :showModeCover="false"
                                              showResult="image" showMode="image" v-model="squareLogoUrl"
                                              :multiple="false"></uploader>
                                </div>
                                <div class="logo-item__text">长Logo（带名称）</div>
                            </div>
                            <!--                            <div class="logo-item logo-item&#45;&#45;qrcode">-->
                            <!--                                <div>-->
                            <!--                                    <uploader openDelete ref="coverUploader" pathPrefix="moduleApp"-->
                            <!--                                              :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" :showModeCover="false"-->
                            <!--                                              showResult="image" showMode="image" v-model="wxqrcode"-->
                            <!--                                              :multiple="false"></uploader>-->
                            <!--                                </div>-->
                            <!--                                <div class="logo-item__text">关注二维码</div>-->
                            <!--                            </div>-->
                            <!--                            <div class="logo-item logo-item&#45;&#45;qrcode">-->
                            <!--                                <div>-->
                            <!--                                    <uploader ref="coverUploader" pathPrefix="moduleApp"-->
                            <!--                                              :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" :showModeCover="false"-->
                            <!--                                              showResult="image" showMode="image" v-model="subscribeQrcode"-->
                            <!--                                              :multiple="false"></uploader>-->
                            <!--                                </div>-->
                            <!--                                <div class="logo-item__text">学校通知二维码</div>-->
                            <!--                            </div>-->
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import Uploader from '@/components/Uploader/WebUploader';
    import LocationSelector from '@/components/LocationSelector';
    import mixin from "@/mixins/windowResize";
    import {telValidator, emailValidator} from '@/utils/validate';
    import {schoolTypeConstants} from '@/utils/constants';
    import {updateSchool, querySchoolDetail, queryGroupSchoolList} from '@/api/schoolManage';
    import {getAllDealerManageList} from '@/api/dealerManage';
    import {getDicByCode} from "@/utils/utils";
    import moment from 'moment';

    export default {
        name: 'schoolEdit',
        components: {Uploader, LocationSelector},
        data() {
            const validateLogo = (rule, value, callback) => {
                if (this.roundLogoUrl.length === 0) {
                    callback(new Error('请上传logo'));
                } else {
                    callback();
                }
            };

            const groupValidator = (rule, value, callback) => {
                if (this.formData.schoolType == 2 && !this.formData.groupName) {
                    callback(new Error('请填写集团名称'));
                } else if (this.formData.schoolType == 3 && !this.formData.groupSchoolId) {
                    callback(new Error('请选择所属总校/总园'));
                } else {
                    callback();
                }
            };
            const thirdSchoolIdValidator = (rule, value, callback) => {
                if (this.formData.thirdSchoolId == '') {
                    callback();
                } else if (!/^[\w-]+$/g.test(this.formData.thirdSchoolId)) {
                    callback(new Error('第三方学校id必须是数字字母下划线或横杠'));
                } else {
                    callback();
                }
            };
            const guestSourceCodeValidator = (rule, value, callback) => {
                if ((this.formData.clientType == 2 || this.formData.clientType == 3 || this.formData.clientType == 12 || this.formData.clientType == 4) && !this.formData.guestSourceCode) {
                    callback('请选择获客来源');
                } else {
                    callback();
                }
            };
            const subBranchCodeValidator = (rule, value, callback) => {
                if ((this.formData.clientType == 2 || this.formData.clientType == 3 || this.formData.clientType == 12 || this.formData.clientType == 4) && !this.formData.subBranchCode) {
                    callback('请选择支行');
                } else {
                    callback();
                }
            };
            const joinDateValidator = (rule, value, callback) => {
                if ((this.formData.clientType == 2 || this.formData.clientType == 3 || this.formData.clientType == 12 || this.formData.clientType == 4) && !this.formData.joinDate) {
                    callback('请选择接入日期');
                } else {
                    callback();
                }
            };
            return {
                schoolId: this.$route.query.schoolId,

                dealerList: [],
                groupList: [],

                schoolTypeConstants,
                formData: {
                    clientType: '1',
                    accessDate: '',
                    corpId: '',
                    name: '',
                    fullName: '',
                    simpleName: '',
                    managerName: '',
                    managerMobile: '',
                    managerEmail: '',
                    bussinessNumber: '',
                    domainName: '',
                    liableNames: '',
                    useNew: 1,
                    suiteType: 1,
                    isTxlx: 2,
                    isNewMobile: 2,
                    syncForWx: 2,
                    syncForWxAddress:2,
                    syncForWxAddressSchool:2,
                    isExternalContact: 2,
                    schoolType: 1,
                    msgType: 1,
                    groupName: '',
                    groupSchoolId: '',
                    thirdSchoolId: '',
                    platformSync: 2,
                    addressBookPerm: 2,
                    ssoDomainName: '',
                    tencentSchoolVersion: 0,
                    isPushdata: 2,
                    originalCorpId: '',

                    subBranchCode: '',
                    guestSourceCode: '',
                    joinDate: ''
                },
                locationArray: ['320000', '320100', '320102'],
                orderRangeArray: ['', '', ''],
                rules: {
                    logo: [
                        {required: true, validator: validateLogo}
                    ],
                    name: [
                        {required: true, message: '请输入学校名称', trigger: 'blur'},
                    ],
                    fullName: [
                        {required: true, message: '请输入学校全称', trigger: 'blur'},
                    ],
                    simpleName: [
                        {required: true, message: '请输入学校简称', trigger: 'blur'},
                    ],
                    managerName: [
                        {required: true, message: '请输入联系人', trigger: 'blur'},
                    ],
                    originalCorpId: [
                        {required: true, message: '请输入企业corpid明文', trigger: 'blur'},
                    ],
                    managerMobile: [
                        {required: true, trigger: 'blur', validator: telValidator},
                    ],
                    managerEmail: [
                        {required: true, trigger: 'blur', validator: emailValidator},
                    ],
                    group: [
                        {required: true, trigger: 'blur', validator: groupValidator},
                    ],
                    thirdSchoolId: [
                        {trigger: 'blur', validator: thirdSchoolIdValidator},
                    ],
                    clientType: [
                        {required: true, message: '请选择客户端类型', trigger: 'blur'},
                    ],
                    guestSourceCode: [
                        {required: true, validator: guestSourceCodeValidator, trigger: 'blur'},
                    ],
                    subBranchCode: [
                        {required: true, validator: subBranchCodeValidator, trigger: 'blur'},
                    ],
                    joinDate: [
                        {required: true, validator: joinDateValidator, trigger: 'blur'},
                    ],
                },
                roundLogoUrl: [],
                squareLogoUrl: [],
                wxqrcode: [],
                subscribeQrcode: [],

                moduleTypeList: [],
                isNewWx: 0,

                branchList: [],
                guestSourceList: []
            }
        },
        mixins: [mixin],
        created() {
            queryGroupSchoolList({
                schoolId: this.schoolId

            })
                .then(data => {
                    this.groupList = data;
                });
            getAllDealerManageList()
                .then(data => {
                    this.dealerList = data;
                });
            querySchoolDetail({
                schoolId: this.schoolId
            })
                .then(data => {
                    console.log('data', data);
                    data.bussinessNumber = data.bussinessNumber == 0 ? '0' : data.bussinessNumber;
                    this.isNewWx = data.isNewWx;
                    if (data.orgAreaCode) {
                        this.locationArray = data.orgAreaCode.split(',');
                    }
                    if (data.orderOrgAreaCode) {
                        this.orderRangeArray = data.orderOrgAreaCode.split(',');
                    }
                    if (!data.isPushdata) {
                        data.isPushdata = 2;
                    }
                    if (!data.joinDate) {
                        data.joinDate = moment().format('YYYY-MM-DD');
                    }
                    this.formData = data;
                    if (data.roundLogoUrl) {
                        this.roundLogoUrl = [{
                            fileUrl: data.roundLogoUrl
                        }];
                    }
                    if (data.squareLogoUrl) {
                        this.squareLogoUrl = [{
                            fileUrl: data.squareLogoUrl
                        }];
                    }
                    if (data.wxqrcode) {
                        this.wxqrcode = [{
                            fileUrl: data.wxqrcode
                        }];
                    }
                    if (data.subscribeQrcode) {
                        this.subscribeQrcode = [{
                            fileUrl: data.subscribeQrcode
                        }];
                    }
                });
            getDicByCode('subBranch')
                .then(branchList => {
                    this.branchList = branchList;
                });
            getDicByCode('guestSource')
                .then(guestSourceList => {
                    this.guestSourceList = guestSourceList;
                })
        },
        methods: {
            onsave() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        const args = {
                            id: this.schoolId,
                            clientType: this.formData.clientType,
                            accessDate: this.formData.accessDate,
                            bussinessNumber: this.formData.bussinessNumber,
                            corpId: this.formData.corpId,
                            domainName: this.formData.domainName,
                            fullName: this.formData.fullName,
                            groupName: this.formData.schoolType == 2 ? this.formData.groupName : '',
                            groupSchoolId: this.formData.schoolType == 3 ? this.formData.groupSchoolId : '',
                            thirdSchoolId: this.formData.thirdSchoolId || '',
                            isPublic: this.formData.isPublic,
                            isTxlx: this.formData.isTxlx,
                            liableNames: this.formData.liableNames,
                            managerEmail: this.formData.managerEmail,
                            managerMobile: this.formData.managerMobile,
                            managerName: this.formData.managerName,
                            msgType: this.formData.msgType,
                            name: this.formData.name,
                            newSchoolSecret: ((this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) && this.formData.isExternalContact == 2) ? (this.formData.newSchoolSecret || '') : '',
                            orgAreaCode: this.locationArray,
                            orgCode: this.formData.orgCode || '',
                            address: this.formData.address || '',
                            schoolType: this.formData.schoolType,
                            simpleName: this.formData.simpleName,
                            type: this.formData.type,
                            suiteType: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.suiteType : '',
                            isExternalContact: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.isExternalContact : 1,
                            useNew: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.useNew : 1,
                            isNewMobile: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.isNewMobile : 2,
                            syncForWx: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.syncForWx : 2,
                            syncForWxAddress: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.syncForWxAddress : 2,
                            syncForWxAddressSchool: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.syncForWxAddressSchool : 2,
                            platformSync: this.formData.platformSync,
                            addressBookPerm: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.addressBookPerm : '',
                            ssoDomainName: this.formData.ssoDomainName,
                            orderRange: this.orderRangeArray.length !== 0 && this.orderRangeArray[0] !== '' ? (this.orderRangeArray[2] == 0 ? this.orderRangeArray[1] : this.orderRangeArray[2]) : '',
                            orderOrgAreaCode: this.orderRangeArray.length !== 0 && this.orderRangeArray[0] !== '' ? this.orderRangeArray : ['', '', ''],
                            orderOrgAreaName: this.orderRangeArray.length !== 0 && this.orderRangeArray[0] !== '' ? this.$refs.locationSelectorOrderRange.getNameArray().join(' ') : '',
                            tencentSchoolVersion: (this.formData.clientType == 1 || this.formData.clientType == 12 || this.formData.clientType == 4) ? this.formData.tencentSchoolVersion : 0,
                            isPushdata: this.formData.isPushdata,
                        };
                        const dealerObj = this.dealerList.find(item => item.bussinessNumber == this.formData.bussinessNumber);
                        args.bussinessName = dealerObj ? dealerObj.bussinessName : '';

                        args.roundLogoUrl = this.roundLogoUrl[0].fileUrl;
                        if (this.squareLogoUrl && this.squareLogoUrl.length !== 0) {
                            args.squareLogoUrl = this.squareLogoUrl[0].fileUrl;
                        } else {
                            args.squareLogoUrl = '';
                        }
                        if (this.wxqrcode && this.wxqrcode.length !== 0) {
                            args.wxqrcode = this.wxqrcode[0].fileUrl;
                        } else {
                            args.wxqrcode = '';
                        }
                        if (this.subscribeQrcode && this.subscribeQrcode.length !== 0) {
                            args.subscribeQrcode = this.subscribeQrcode[0].fileUrl;
                        } else {
                            args.subscribeQrcode = '';
                        }
                        if (this.isNewWx == 1) {
                            args.originalCorpId = this.formData.originalCorpId;
                        }
                        args.orgAreaName = this.$refs.locationSelector.getNameArray().join(' ');
                        args.areaCode = this.locationArray[2] == '0' ? (this.locationArray[1] == '0' ? (this.locationArray[0] == '' ? '' : this.locationArray[0]) : this.locationArray[1]) : this.locationArray[2];


                        if (this.formData.clientType == 2 || this.formData.clientType == 3 || this.formData.clientType == 12 || this.formData.clientType == 4) {
                            const branchObj = this.branchList.find(item => item.code == this.formData.subBranchCode);
                            if (branchObj) {
                                args.subBranchCode = branchObj.code;
                                args.subBranch = branchObj.value;
                            }
                            const guestSourceObj = this.guestSourceList.find(item => item.code == this.formData.guestSourceCode);
                            if (guestSourceObj) {
                                args.guestSourceCode = guestSourceObj.code;
                                args.guestSource = guestSourceObj.value;
                            }
                            args.joinDate = this.formData.joinDate;
                        } else {
                            args.subBranchCode = '';
                            args.subBranch = '';
                            args.guestSourceCode = '';
                            args.guestSource = '';
                            args.joinDate = '';
                        }

                        updateSchool(args)
                            .then(() => {
                                this.$message.success(`编辑成功`);
                                window.setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            });
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "../../styles/mixin";

    #schoolEdit {
        padding: 12px;

        .title {
            border-left: 4px solid #409EFF;
            padding-left: 12px;
            height: 16px;
            line-height: 16px;
            margin-bottom: 22px;

            &:not(:first-of-type) {
                margin-top: 40px;
            }
        }

        .img-upload {
            float: none;
            margin: 0 auto;
        }

        .upload-file-item {
            width: auto;
        }

        .logo-list {
            margin-top: 20px;

            & > * {
                @include middleIB;
            }

            .logo-item {
                text-align: center;
                margin-right: 10px;
                font-size: 14px;
                /*min-width: 130px;*/

                img {
                    height: 100px;
                    width: auto;
                }

                .logo-item__text {
                    clear: left;
                }
            }
        }

        .top {
            border-bottom: 1px solid #e7eaec;
            padding-bottom: 10px;
        }

        .body {
            overflow: auto;
        }

        .upload-block-container .upload-file-item {
            margin-right: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolEdit.vue